import { IQService } from 'angular';
import { DivisionService, PayStubService } from '../../../core/services';
import { UtilityService } from '../../../core/services/utility.service';
import { CancelValue, ValueEmitter } from '../../shared/modals/modal-types';
import templateUrl from './pay-stub-modal.component.html';

export const PayStubModal = {
    windowClass: 'xx-dialog pagespinner',
    component: "apexPayStubModal",
    size: 'xl',
    backdrop: 'static',
}

export const PayStubModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class {
        resolve: any;
        close: ValueEmitter<CancelValue>;
        dismiss: ValueEmitter<any>
        loaded: boolean;
        state: any;
        payWeek: any;
        payStub: any;
        payrollID: number;
        reportName: string;
        divisions: any[];

        constructor(private $q: IQService, private divisionService: DivisionService,
            private utilityService: UtilityService, private payStubService: PayStubService) {
            'ngInject'
            this.loaded = false;
            this.state = null;
        }

        $onInit() {
            this.payWeek = this.resolve.payWeek;
            this.reportName = this.payWeek.isPayStub ? 'Pay Stub Statement' : 'Gross Pay Statement';
            this.utilityService.showLoading();
            return this.loadDivisions()
                .then(() => {
                    return this.loadPayStub();
                })
                .then(() => {
                    this.utilityService.hideLoading();
                    this.loaded = true;
                })
                .catch(ex => {
                    console.error("Loading page failed " + ex.statusText);
                    throw ex;
                });
        }

        loadPayStub() {
            if (!this.payWeek) {
                this.payStub = null;
                return this.$q.when();
            }
            return this.payStubService.retrievePayStub(this.payWeek.payrollID, this.payWeek.employeeID,
                this.payWeek.icdCorporationID)
                .then(payStub => {
                    this.payStub = payStub;
                    this.hydrateDivisionRegularCommissions(this.payStub.PayStubEntries);
                    this.payrollID = payStub.PayrollID;
                    return payStub;
                })
                .catch(ex => {
                    console.error("Retrieving the pay stub failed. " + ex.statusText);
                    throw ex;
                });
        }

        loadDivisions() {
            return this.divisionService.retrieveDivisions()
                .then(divisions => {
                    this.divisions = divisions
                    return this.divisions;
                });
        }


        hydrateDivisionRegularCommissions(entries) {
            entries.forEach(entry => {
                entry.DivisionRegularCommissionList = this.divisions.reduce((list, division) => {
                    const commission = entry.DivisionRegularCommissions[division.Id];
                    if (commission) {
                        division.CommissionAmount = commission;
                        list.push(division);
                    }
                    return list;
                }, []);
            });
        }

        onCancel() {
            this.dismiss({ $value: 'cancel' });
        }

    }
}
